import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

const tagTypeLengths = {
  standard: 40,
  mini: 22,
  flap: 115,
};

const tagTypeOptions = [
  { value: "standard", label: "Standard", sub: "40mm" },
  { value: "mini", label: "Mini", sub: "22mm" },
  { value: "flap", label: "Flap", sub: "115mm" },
  { value: "custom", label: "Custom", sub: "set length" },
];

const FieldLabel = ({ children }) => (
  <div
    style={{
      color: "#6b7280",
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      marginBottom: 8,
    }}
  >
    {children}
  </div>
);

const inputStyle = {
  width: "100%",
  backgroundColor: "#fff",
  border: "1.5px solid #e5e7eb",
  borderRadius: 10,
  padding: "10px 14px",
  fontSize: 14,
  color: "#111827",
  outline: "none",
  transition: "border-color 0.15s, box-shadow 0.15s",
};

const focusHandlers = {
  onFocus: (e) => {
    e.target.style.borderColor = "#ff5100";
    e.target.style.boxShadow = "0 0 0 3px rgba(255,81,0,0.1)";
  },
  onBlur: (e) => {
    e.target.style.borderColor = "#e5e7eb";
    e.target.style.boxShadow = "none";
  },
};

const CreateOrder = ({ domain, show, handleClose, handleFormSubmit }) => {
  const [tagType, setTagType] = useState("");
  const [lengthValue, setLengthValue] = useState("");
  const [lengthDisabled, setLengthDisabled] = useState(true);
  const [purpose, setPurpose] = useState("production");
  const [quantity, setQuantity] = useState("");
  const [description, setDescription] = useState("");

  const handleTagTypeChange = (value) => {
    setTagType(value);
    if (value === "custom") {
      setLengthDisabled(false);
      setLengthValue("");
    } else {
      setLengthDisabled(true);
      setLengthValue(tagTypeLengths[value] || "");
    }
  };

  const handleSubmit = async () => {
    if (!tagType || !lengthValue || !quantity || !description) {
      alert("Please fill all required fields.");
      return;
    }

    const payload = {
      quantity: parseInt(quantity),
      metadata: {
        type:
          tagType === "custom"
            ? "Custom"
            : tagType.charAt(0).toUpperCase() + tagType.slice(1),
        length: parseInt(lengthValue),
        purpose,
        description,
      },
      user: "admin@iriscrypt.com",
    };

    try {
      const response = await fetch("https://api.iriscrypt.com/order", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "f87f030d-eaf4-4a39-9d5d-c9ffdb90ab43",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (response.ok && result.success) {
        handleClose();
        handleFormSubmit();
      } else {
        alert(result?.detail || "Failed to place order.");
      }
    } catch (error) {
      console.error("Order submit error:", error);
      alert("An error occurred.");
    }
  };

  return (
    <>
      <style>{`
        .create-order-modal .modal-content {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 18px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.12);
        }
        .create-order-modal .modal-header {
          background: #fff;
          border-bottom: 1px solid #f3f4f6;
          border-radius: 18px 18px 0 0;
          padding: 20px 24px 16px;
        }
        .create-order-modal .modal-body {
          background: #fff;
          padding: 20px 24px;
        }
        .create-order-modal .modal-footer {
          background: #f9fafb;
          border-top: 1px solid #f3f4f6;
          border-radius: 0 0 18px 18px;
          padding: 16px 24px;
        }
      `}</style>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="create-order-modal"
        centered
        style={{ backdropFilter: "blur(3px)" }}
      >
        <Modal.Header closeButton>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                background: "rgba(255,81,0,0.08)",
                border: "1.5px solid rgba(255,81,0,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                className="fas fa-shopping-cart"
                style={{ color: "#ff5100", fontSize: 13 }}
              />
            </div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 16, color: "#111827" }}>
                Place Order
              </div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 1 }}>
                Order BleST tags from IrisCrypt Inc.
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {/* Tag Type */}
          <div>
            <FieldLabel>Tag Type *</FieldLabel>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 8,
              }}
            >
              {tagTypeOptions.map((opt) => {
                const selected = tagType === opt.value;
                return (
                  <button
                    key={opt.value}
                    onClick={() => handleTagTypeChange(opt.value)}
                    style={{
                      padding: "10px 14px",
                      borderRadius: 10,
                      border: `1.5px solid ${selected ? "#ff5100" : "#e5e7eb"}`,
                      background: selected ? "rgba(255,81,0,0.06)" : "#fff",
                      cursor: "pointer",
                      textAlign: "left",
                      transition: "border-color 0.15s, background 0.15s",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: 13,
                        color: selected ? "#ff5100" : "#111827",
                      }}
                    >
                      {opt.label}
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        color: selected ? "#f97316" : "#9ca3af",
                        marginTop: 2,
                      }}
                    >
                      {opt.sub}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Length — only shown for custom */}
          {tagType === "custom" && (
            <div style={{ marginTop: 16 }}>
              <FieldLabel>Sticker Length (mm) *</FieldLabel>
              <input
                type="number"
                value={lengthValue}
                onChange={(e) => setLengthValue(e.target.value)}
                placeholder="Enter length in mm"
                style={inputStyle}
                {...focusHandlers}
              />
            </div>
          )}

          {/* Length display for preset types */}
          {tagType && tagType !== "custom" && (
            <div style={{ marginTop: 16 }}>
              <FieldLabel>Sticker Length</FieldLabel>
              <div
                style={{
                  padding: "10px 14px",
                  borderRadius: 10,
                  background: "#f9fafb",
                  border: "1.5px solid #e5e7eb",
                  fontSize: 14,
                  color: "#374151",
                  fontWeight: 600,
                }}
              >
                {lengthValue}mm
              </div>
            </div>
          )}

          {/* Purpose */}
          <div style={{ marginTop: 16 }}>
            <FieldLabel>Purpose *</FieldLabel>
            <div style={{ display: "flex", gap: 8 }}>
              {["production", "demo"].map((opt) => {
                const selected = purpose === opt;
                return (
                  <button
                    key={opt}
                    onClick={() => setPurpose(opt)}
                    style={{
                      flex: 1,
                      padding: "10px 0",
                      borderRadius: 10,
                      border: `1.5px solid ${selected ? "#ff5100" : "#e5e7eb"}`,
                      background: selected ? "rgba(255,81,0,0.06)" : "#fff",
                      fontWeight: 700,
                      fontSize: 13,
                      color: selected ? "#ff5100" : "#6b7280",
                      cursor: "pointer",
                      transition:
                        "border-color 0.15s, background 0.15s, color 0.15s",
                      textTransform: "capitalize",
                    }}
                  >
                    {opt}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Quantity */}
          <div style={{ marginTop: 16 }}>
            <FieldLabel>Quantity *</FieldLabel>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              placeholder="e.g. 500"
              style={inputStyle}
              {...focusHandlers}
            />
          </div>

          {/* Description */}
          <div style={{ marginTop: 16 }}>
            <FieldLabel>Description *</FieldLabel>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Brief description of this order…"
              rows={3}
              style={{ ...inputStyle, resize: "vertical", minHeight: 90 }}
              {...focusHandlers}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            onClick={handleSubmit}
            style={{
              width: "100%",
              padding: "11px 0",
              borderRadius: 10,
              border: "none",
              background: "linear-gradient(135deg, #c13d00 0%, #ff5100 100%)",
              color: "#fff",
              fontWeight: 700,
              fontSize: 15,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 9,
            }}
          >
            Place Order
            <i
              className="fas fa-arrow-right"
              style={{ fontSize: 13 }}
            />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateOrder;
